import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {CoreSidebarService} from '../../../@core/components/core-sidebar/core-sidebar.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AlertService} from '../../shared/services/alert.service';
import {NewsCategoryService} from '../../shared/services/news-category.service';

@Component({
    selector: 'app-news-blog-categories',
    templateUrl: './news-categories.component.html',
    styleUrls: ['./news-categories.component.scss']
})
export class NewsCategoriesComponent implements OnInit {
    showSearch = false;
    id: any;
    data: any;
    submitted: any = false;
    submitting: any = false;
    searchForm: FormGroup;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    newsCategories = [];
    onFileChanged: any;

    constructor(private router: Router,
                private _coreSidebarService: CoreSidebarService,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private newsCategoryService: NewsCategoryService,
                private alertService: AlertService) {
    }

    ngOnInit(): void {
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('app-add-news-category').toggleOpen();
    }

    add(): void {
        this.data = undefined;
        this.toggleSidebar();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'name': ['']
        });
        this.get();
    }


    getData(valueSubmit: any): void {
        if (valueSubmit) {
            this.get({page: 1, total: null, perpage: 15, pages: null});
            this.toggleSidebar();
        }
    }

    onFileChange(e, type, data) {
        this.onFileChanged = e;
        this.newsCategoryService.fileUploadAdmin({
            'type': type,
            'fileType': 'NORMAL',
            'insight_id': data.id
        }, this.onFileChanged).subscribe(data => {
            if (type === 'NEWS_CATEGORY_BANNER') {
                if (data && data['data']) {
                    this.get();
                }
            }
            this.alertService.showSuccess({title: 'Success', message: 'Uploaded Successfully'});
        }, error => {
            this.alertService.showErrors('Something went wrong, please try again');
        });
    }

    openInsightBanner(data) {
        window.open(data['news_category_banner']['url'], '_blank');
    }

    // viewContent(content, data) {
    //     this.viewContentData = data;
    //     this.modalService.open(content);
    // }

    search() {
        const params = {
            'name': (this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : ''
        };
        this.get(params);
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            name: (this.searchForm && this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : ''
        };
        this.get(params);
    }

    edit(data) {
        this.data = data;
        this.toggleSidebar();
    }

    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.newsCategories = [];
        this.newsCategoryService.get(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.newsCategories = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.newsCategories = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    updateStatus(data, status) {
        this.newsCategoryService.updateStatus(data.id, {'status': status}).subscribe(data => {
            this.submitting = false;
            this.submitted = false;
            this.get();
        }, error => {
            this.submitting = false;
            this.submitted = false;
        });
    }

    delete(id) {
        this.newsCategoryService.delete(id).subscribe(data => {
            this.get();
        });
    }
}
